import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48baf4d4")

_pushScopeId("data-v-48baf4d4")
const _hoisted_1 = { class: "shoppinglisteditmenu-overlay" }
const _hoisted_2 = { class: "shoppinglisteditmenu-contents" }
const _hoisted_3 = { class: "shoppinglisteditmenu-contents-item-text shoppinglisteditmenu-contents-item-text-delete" }
const _hoisted_4 = { class: "shoppinglisteditmenu-contents-item-text" }
const _hoisted_5 = { class: "shoppinglisteditmenu-contents-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "shoppinglisteditmenu" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", {
              class: "shoppinglisteditmenu-contents-item shoppinglisteditmenu-contents-separator",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteClicked(...args)))
            }, [
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.deleteText), 1)
            ]),
            (_ctx.isValidFavorite)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "shoppinglisteditmenu-contents-item shoppinglisteditmenu-contents-separator",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.favoriteClicked(...args)))
                }, [
                  _createVNode("span", _hoisted_4, _toDisplayString(_ctx.appendText), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "shoppinglisteditmenu-contents-item",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelClicked(...args)))
            }, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cancelText), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowMenu]
        ])
      ]),
      _: 1
    })
  ]))
})